<template>
  <section class="section">
    <h4 class="label">{{ $t('pages.CompaniesStorePost.couponCode') }}</h4>

    <label>
      <input v-model="couponCodeText" type="text" class="c-textField">
    </label>
  </section>

  <section class="section">
    <div class="formLabelWrapper">
      <h4 class="label">{{ $t('pages.CompaniesStorePost.linkToRedeemOffer') }}{{ includesDocomo ? $t('labels.requiredLabel') : $t('labels.optionalLabel') }}</h4>
      <KkInsertParameter
        :parameters="availableParameters"
        :loading="parameterLoading"
        @insert-parameter="insertParam"
      />
    </div>
    <ValidationProvider v-slot="{ errors, value, handleChange }" v-model="redeemOnlineUrlText" :rules="redeemOnlineUrlRules" name="利用特典へのリンク">
      <label>
        <input ref="onlineUrl" :value="value" type="text" class="c-textField" @input="handleChange">
      </label>
      <ValidationError
        id="redeemOnlineUrl"
        :error="errors[0]"
      />
    </ValidationProvider>
    <div class="infoParameter">
      <Info>
        {{ $t('pages.CompaniesStorePost.linkParameter', { beforeURL: "https://example.com/{STORE_CODE}" }) }}
      </Info>
    </div>
  </section>

  <section class="section">
    <h4 class="label">{{ $t('pages.CompaniesStorePost.termsAndCondition') }}</h4>
    <label>
      <input v-model="termsConditionsText" type="text" class="c-textField">
    </label>
  </section>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Info from '../Info'
import { KkInsertParameter } from '../../components/projects'
import ValidationError from '../ValidationError'

export default {
  name: 'Offer',
  components: {
    Info,
    KkInsertParameter,
    ValidationError
  },
  props: {
    availableParameters: {
      type: Array,
      default: () => []
    },
    parameterLoading: {
      type: Boolean,
      required: false
    },
  },
  computed: {
    ...mapState('companiesStorePosts', ['post']),
    couponCodeText: {
      get() {
        return this.post.offer.couponCode
      },
      set(couponCode) {
        this.updateCouponCode(couponCode)
      }
    },
    redeemOnlineUrlText: {
      get() {
        return this.post.offer.redeemOnlineUrl
      },
      set(redeemOnlineUrl) {
        this.updateRedeemOnlineUrl(redeemOnlineUrl)
      }
    },
    termsConditionsText: {
      get() {
        return this.post.offer.termsConditions
      },
      set(termsConditions) {
        this.updateTermsConditions(termsConditions)
      }
    },
    includesDocomo() {
      if (!this.post.services) return false
      return this.post.services.includes('docomo')
    },
    redeemOnlineUrlRules() {
      return this.includesDocomo ? 'required|url' : 'url'
    }
  },
  methods: {
    ...mapMutations('companiesStorePosts', [
      'updateCouponCode',
      'updateRedeemOnlineUrl',
      'updateTermsConditions',
    ]),
    insertParam (parameterName) {
      const pos = this.$refs.onlineUrl.selectionStart
      const before = this.redeemOnlineUrlText.substring(0, pos)
      const after = this.redeemOnlineUrlText.substring(pos, this.redeemOnlineUrlText.length)
      this.redeemOnlineUrlText = before + parameterName + after
    }
  }
}
</script>

<style lang="scss" scoped>
.label {
  margin-bottom: 8px;
  font-size: 12px;
}
.infoParameter {
  margin-top: 16px;
}
.formLabelWrapper {
  display: flex;
  justify-content: space-between;
}
.section {
  margin-top: 32px;
}
</style>
